export default {
	qita: 'Lain',
	chengjirenyixuanze: 'Penumpang sudah memilih, tidak dapat memilih lagi',
	dingdanzhuangtai: 'Status perintah',
	daifukuan: 'Pembayaran yang menunggu',
	daichupiao: 'Keluaran tiket menunggu',
	chupiaowancheng: 'Keluaran tiket selesai',
	quxiao: 'Batalkan',
	yinhangka: 'Kartu Bank',
	dianziqianbao: 'Dompet Elektronik',
	yiwancheng: 'Selesai',
	weiwancheng: 'Bertahanlah di udara',
	quxiaozhong: 'Membatalkan',
	zhifuzhong: 'Dalam pembayaran',
	chongxinxuanzezhifufangshi: 'Pilih metode pembayaran baru',
	zhifuweiwancheng: 'Pembayaran belum selesai',
	jixuzhifu: 'Lanjutkan pembayaran',
	chongxingoumai: 'Membeli ulang',
	ninhaiweiwanchengzhifu: 'Anda belum menyelesaikan pembayaran. Apakah Anda ingin melanjutkan pembayaran?',
	quebaoziliao: 'Harap pastikan semua informasi sudah benar.',
	lianluorenziliao: 'Informasi Kontak',
	dianhuahaoma: 'Nomor Telepon',
	fujiafuwu: 'Fitur tambahan',
	feixingchangkehaoma: 'Nomor Frequent Flyer',
	dianziyouhuiquan: 'Elektronik Kupon',
	meiyoudianziyouhui: 'Jangan gunakan elektronik kupon',
	wodedaima: 'Saya punya kode',
	jiayiri: 'Hari',
	jiaerri: 'Hari',
	xianzaifukuan: 'Bayar Sekarang',
	yudaowenti: 'Menemukan masalah',
	qingninzaixindakaideyemian: 'Tolong bayar di halaman yang baru dibuka!',
	zhifuwanchengqianqingbuyao: 'Tolong jangan tutup jendela ini sampai pembayaran selesai',
	querenzhifu: 'Konfirmasi pembayaran',
	cuowuyuanyin: 'Alasan kesalahan',
	zhifucuowu: 'Galat Pembayaran',
	bizhongbuzhichi: 'Uang tidak didukung',
	jinechaochuxianzhi: 'Jumlah melebihi batas',
	xiugai: 'Ubah',
	xiangqing: 'Detail',
	chengke: 'Penumpang',
	daililianluoziliao: 'Detail Kontak Agen',
	banlidengji: 'Check-In',
	chakanguanli: 'Lihat/Kelola',
	chufa: 'Keberangkatan',
	riqishijian: 'Tanggal/Waktu',
	yudingcankaobianhao: 'Referensi Pemesanan',
	chengshijichang: 'Kota/Bandara',
	dao: 'Mencapai',
	daoda: 'Kedatangan',
	daodashijian: 'Waktu kedatangan',
	xingcheng: 'Rencana Perjalanan',
	lieyin: 'Cetak',
	shuikuanfapiao: 'Faktur Pajak',
	genggaihangbanyaoqiu: 'Syarat Perubahan Penerbangan',
	lvxingshijian: 'Waktu Perjalanan',
	xinglie: ' Bagasi',
	nian: ' Tahun',
	yue: ' Bulan',
	geshibuzhengque: ' Kesalahan Format',
	lianxirenxingming: ' Nama Kontak',
	tuipiao: 'Pengembalian Tiket',
	gaiqian: 'Pesan Ulang',
	querenyaotuipiaoma: 'Apakah Anda yakin ingin mengembalikan tiket?',
	querenyaogaiqianma: 'Apakah Anda yakin ingin mengubah tanda tangan?',
	pingtaifuwufei: 'Biaya Layanan Platform',
	xuzhifu: 'Biaya Yang Dibayar',
	jishufuwufei: 'Biaya Layanan Teknis',
	shouxufei: 'Commission',
	xinglixinxi: 'Informasi Bagasi',
	xingli: 'Bagasi',
	dingdanxinxi: 'Informasi perintah',
	dingdantijiaochenggong: 'Perintah dihantar dengan sukses',
	qingzhifu: 'Silakan membayar dalam 30 menit, jika tidak perintah akan dibatalkan.',
	kezailiebiaochakan: 'Anda dapat melihat "perintah" saya dalam daftar perintah',
	chakandingdan: 'Lihat perintah',
	ri: 'hari',
	yiyue: 'Januari',
	eryue: 'Februari',
	sanyue: 'Maret',
	siyue: 'April',
	wuyue: 'Mei',
	liuyue: 'Juni',
	qiyue: 'Juli',
	bayue: 'Agustus',
	jiuyue: 'September',
	shiyue: 'Oktober',
	shiyiyue: 'November',
	shieryue: 'Desember',
	xuanzefukuanfangshi: 'Pilih metode pembayaran',
	qingyu: 'Harap selesaikan pembayaran sebelum pukul',
	neiwanchengzhifu: ' ',
	kaxinxi: 'Informasi Kartu',
	xinyongkahao: 'Nomor kartu kredit',
	xinyongkayouxiaoqi: 'Masa berlaku kartu kredit',
	chikarenxingshi: "Last name",
	chikarenmingzi: "Given names",
	youxiang: 'Email',
	dianhua: 'Telepon',
	shengfendiqu: 'Provinsi/Wilayah',
	chengshi: 'kota',
	youbian: 'Alamat kode pos',
	jiedaodizhi: 'Alamat jalan',
	zhangdanxinxi: 'Informasi tagihan',
	dingdanbianhao: 'Nomor pesanan:',
	dingdanbizhong: 'Mata uang pesanan:',
	dingdanjine: 'Jumlah pesanan:',
	guojia: 'Country',
	zhuan: 'Putar',
	ci: 'Selanjutnya',
	fen: 'm',
	miao: 's',
};
